import { render, staticRenderFns } from "./level.vue?vue&type=template&id=385e5456&scoped=true"
import script from "./level.vue?vue&type=script&lang=js"
export * from "./level.vue?vue&type=script&lang=js"
import style0 from "./level.vue?vue&type=style&index=0&id=385e5456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385e5456",
  null
  
)

export default component.exports